<template>
  <b-modal size="lg" hide-footer id="modal-categories" title="Catégories">
    <b-row class="mb-2">
      <b-col sm="6" class="w-100">
        <b-list-group v-for="cat in categories" :key="cat.id">
          <b-list-group-item>
            <b-input-group  :prepend="cat.id">
            <b-form-input
              :value="cat.name"
              @update="submitUpdate($event, cat.id)"
              debounce="1000"
            ></b-form-input>
            </b-input-group>
          </b-list-group-item>
        </b-list-group>
        <!-- <b-form-group label="Catégories" label-for="sort-by-select">
            <b-form-select
              v-model="categories"
              multiple
              :options="categories"
              :select-size="categories.length"
            ></b-form-select>
          </b-form-group> -->
      </b-col>

      <b-col sm="6">
        <b-card bg-variant="light">
          <b-form @submit.prevent="onSubmit">
            <b-form-group
              label="Nom catégorie"
              label-for="nested-diagnostic"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input
                v-model="form.name"
                @update="updateInput"
                required
              ></b-form-input>
            </b-form-group>
            <b-button
              :disabled="disabled"
              block
              class="mt-3 mb-3"
              type="submit"
              variant="primary"
            >
              Ajouter
              <b-spinner small class="ml-3" v-if="isLoading"></b-spinner>
            </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
// require("json-circular-stringify");

export default {
  name: "ModalCategories",
  data() {
    return {
      form: {
        name: "",
      },
      categories: [],
      isLoading: false,
      edit: false,
      disabled: false,
    };
  },
  components: {},
  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId === "modal-categories") {
        this.getCategories();
      }
    });
    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-categories") {
        this.categories = [];
      }
    });
  },
  methods: {
    getCategories() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/getCategories", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((res) => res.json())
        .then((rep) => {
          // console.log(rep);

          this.categories = rep
            .map((item) => {
              item.value = item;
              item.text = item.name;
              return { ...item };
            })
            .sort((a, b) => a.id - b.id);
        });
    },
    onSubmit() {
      this.isLoading = true;

      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/saveCategory", {
        method: "POST",
        body: JSON.stringify(this.form),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((res) => res.json())
        .then((rep) => {
          this.isLoading = false;
          console.log(rep);
          this.success = true;
          this.getCategories();
          this.form.name = "";
          if (rep.status === 200) {
            // this.form = {
            //   usages: [],
            //   technology: {},
            //   partsAndSpecificities: [
            //     { part: { name: "" }, specificities: [{ name: "" }] },
            //   ],
            //   specificities: [{ name: "", part: {} }],
            //   name: "",
            // };
            this.variant = "success";
            if (this.edit) {
              this.message = "Système modifié avec succès";
            } else {
              this.message = "Système ajouté avec succès";
            }
          } else {
            this.variant = "danger";

            this.message = "Erreur lors  de l'enregistrement";
          }
          setTimeout(() => {
            this.success = false;
          }, 6000);
        })
        .catch((error) => {
          this.errorMessage = error;
          console.error("There was an error!", error);
          this.isLoading = false;
        });
    },
    submitUpdate(newName, catId) {
      console.log(newName, catId);
      this.isLoading = true;

      fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/component/updateCategory",
        {
          method: "POST",
          body: JSON.stringify({ newName, id: catId }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then((rep) => {
          this.isLoading = false;
          console.log(rep);
          this.success = true;
          this.getCategories();
        });
    },
    updateInput() {
      console.log(this.categories);
      this.disabled = this.categories.some((item) =>
        item.name.includes(this.form.name)
      );
    },
  },
};
</script>
<style></style>
